import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/**
 * Dual-axis picker for chart visuals (bar/line/combo) with 2+ measures.
 * Lets the user pick which measure goes on the right (secondary) Y-axis.
 *
 * Hidden when:
 *   - fewer than 2 measures are configured, OR
 *   - the current viz type doesn't support dual axis.
 */
const DUAL_AXIS_VIZ_TYPES = new Set(['bar_chart', 'line_chart', 'combo']);

export function DualAxisPicker({ vizType, valueMeasures, dualAxisField, setDualAxisField }) {
  if (!DUAL_AXIS_VIZ_TYPES.has(vizType)) return null;
  if (valueMeasures.length < 2) return null;

  return (
    <div className="p-3 border-b border-border/30">
      <p className="text-[9px] text-muted-foreground uppercase tracking-wider font-semibold mb-1">Dual Axis</p>
      <Select
        value={dualAxisField || '_none_'}
        onValueChange={v => setDualAxisField(v === '_none_' ? '' : v)}
      >
        <SelectTrigger className="h-6 text-[9px] rounded bg-muted/30 border-border/30" data-testid="dual-axis-trigger">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_none_">Off (single axis)</SelectItem>
          {valueMeasures.map(m => (
            <SelectItem key={m} value={m}>{m.replace(/_/g, ' ')} on right axis</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
